// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--4aUs9","content":"content--35T5h","buttons":"buttons--wPTji"};